//#region src/version.ts
const VERSION = "2.11.0";
//#endregion
export { VERSION };

//# sourceMappingURL=version.js.map